/** A tiny toast queue, usable from anywhere (store, handlers) without React context. */
export type ToastTone = 'info' | 'positive' | 'caution' | 'alert';
export interface ToastItem {
  id: number;
  message: string;
  tone: ToastTone;
  action?: { label: string; run: () => void };
  ttl: number;
}

let items: ToastItem[] = [];
let seq = 0;
const listeners = new Set<() => void>();
const notify = (): void => listeners.forEach((fn) => fn());

export function toast(
  message: string,
  opts: { tone?: ToastTone; action?: { label: string; run: () => void }; ttl?: number } = {},
): number {
  // Collapse duplicates (e.g. five lights failing at once) into one.
  const dup = items.find((t) => t.message === message);
  if (dup) return dup.id;
  const id = ++seq;
  items = [...items.slice(-2), { id, message, tone: opts.tone ?? 'info', ttl: opts.ttl ?? 4200, ...(opts.action ? { action: opts.action } : {}) }];
  notify();
  return id;
}

export function dismissToast(id: number): void {
  items = items.filter((t) => t.id !== id);
  notify();
}

export const toastStore = {
  subscribe(fn: () => void): () => void {
    listeners.add(fn);
    return () => listeners.delete(fn);
  },
  get: (): ToastItem[] => items,
};
